/* eslint-disable import/named */
import requestExodusConfig from 'config/requestExodus';
import { API_EXODUS_URL } from 'constants/api';
import { APIResponse } from '../../../@types/api-response';

const requestExodus = requestExodusConfig();

/**
 * Create Token
 */
export const createToken = (): Promise<APIResponse> =>
  requestExodus.post(`${API_EXODUS_URL}/academy/tokens/new`);

/**
 * Get Unboxing Content
 * @returns {APIResponse}
 */
export const getUnboxings = (): Promise<APIResponse> =>
  requestExodus.get(`${API_EXODUS_URL}/academy/unboxing?limit=5`);

/**
 * Get List Modules
 * @returns {APIResponse}
 */
export const getModules = (): Promise<Response> =>
  fetch(`${API_EXODUS_URL}/academy/modules`, { method: 'get' });

/**
 * Get List Lesson From Chapters
 * @param {number} chapterId - chapter id
 * @returns {APIResponse}
 */
export const getChapterLessons = (chapterId: number): Promise<Response> =>
  fetch(`${API_EXODUS_URL}/academy/lessons?chapter_id=${chapterId}`, {
    method: 'get',
  });

/**
 * Get Unboxing Detail
 * @param {number} unboxingId - unboxing id
 * @returns {APIResponse}
 */
export const getUnboxingDetail = (unboxingId: number): Promise<Response> =>
  fetch(`${API_EXODUS_URL}/academy/unboxing/${unboxingId}`, { method: 'get' });

export default {
  createToken,
  getUnboxings,
};
